import React from 'react';
import PropTypes from 'prop-types';
import compact from 'lodash/compact';
import flatten from 'lodash/flatten';
import { Link, useLocation } from 'react-router-dom';
import 'components/ui/breadcrumb.scss';

const Breadcrumb = ({ crumbs, className }) => {
  return (
    <nav aria-label="breadcrumb" data-cy="breadcrumb" className={`breadcrumb ${className || ''}`}>
      <ol className="breadcrumb-list">
        {crumbs.map((crumb, index) => {
          return (
            <li key={index} className="breadcrumb-list-item">
              {crumb.to ? (
                <Link to={crumb.to} className="breadcrumb-link">
                  {crumb.label}
                </Link>
              ) : (
                <span className="breadcrumb-current">{crumb.label}</span>
              )}
              {!crumb.isLast && <span className="breadcrumb-separator">/</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

Breadcrumb.defaultProps = {
  crumbs: [],
};

Breadcrumb.propTypes = {
  crumbs: PropTypes.array,
  className: PropTypes.string,
};

export default Breadcrumb;
